import styles from "../../styles/pages/Admin.module.css";
import { MailAccountCardRow, MAIL_ACCOUNT_BODY_COLUMNS } from "../../ui/cards/AdminCards";
import { ReactComponent as Vector9Icon } from "../../assets/images/vector_arrow.svg";
import MailAccountDetailModal from "./MailAccountDetailModal";
import CreateMailAccountModal from "./CreateMailAccountModal";
import { assignmentDisplayName, describeMailAccountConnection, hasActiveMailAccountFilters } from "./mailAccountAdminHelpers";

function HeaderCell({ children, column, align = "left" }) {
  return (
    <div
      style={{
        gridColumn: column,
        textAlign: align,
        color: "var(--color-text-text-primary)",
        fontSize: 14,
        fontFamily: "DM Sans",
        fontWeight: 500,
        lineHeight: "17px",
        minWidth: 0,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </div>
  );
}

function MailAccountsTable({ rows, emptyMessage, onSelect }) {
  if (!rows.length) {
    return <div className={styles.emptyState}>{emptyMessage}</div>;
  }

  return (
    <div className={styles.tableContainer}>
      <div className={styles.table}>
        <div className={styles.headerContainer}>
          <div className={styles.headerBody}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: MAIL_ACCOUNT_BODY_COLUMNS,
                alignItems: "center",
                minWidth: 0,
              }}
            >
              <HeaderCell column="1">Casilla</HeaderCell>
              <HeaderCell column="2">Cuenta</HeaderCell>
              <HeaderCell column="3">Conexión</HeaderCell>
              <HeaderCell column="4">Responsables</HeaderCell>
            </div>
          </div>
          <div className={styles.headerActionSpacer} />
        </div>

        {rows.map((mailAccount) => {
          const connection = describeMailAccountConnection(mailAccount);
          const responsibles = (mailAccount.users ?? []).map((assignment) => ({
            id: assignment.id,
            name: assignmentDisplayName(assignment),
          }));
          return (
            <div
              key={`mail-account-${mailAccount.id}`}
              className={styles.rowWrapper}
              role="button"
              tabIndex={0}
              aria-label={`Ver casilla ${mailAccount.email}`}
              onClick={() => onSelect(mailAccount)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelect(mailAccount);
                }
              }}
            >
              <MailAccountCardRow
                name={mailAccount.name}
                email={mailAccount.email ?? "-"}
                accountName={mailAccount.account_name ?? "-"}
                connectionLabel={connection.label}
                connectionWarning={connection.warning}
                responsibles={responsibles}
                actionIcon={<Vector9Icon />}
                onAction={() => onSelect(mailAccount)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function MailAccountsAdminTab({
  accounts = [],
  mailAccounts,
  filteredMailAccounts = [],
  loadError,
  filters,
  selectedMailAccount,
  openMailAccount,
  closeMailAccount,
  updateSelectedMailAccount,
  removeMailAccount,
  addMailAccount,
  isCreating = false,
  closeCreate,
}) {
  const emptyMessage =
    mailAccounts?.length && hasActiveMailAccountFilters(filters)
      ? "Ninguna casilla coincide con el filtro"
      : "No hay casillas en las cuentas que administrás";

  const defaultAccountId = filters?.accountId || (accounts.length === 1 ? accounts[0].id : "");

  return (
    <>
      {loadError && (
        <div className={styles.emptyState} role="alert">
          {loadError}
        </div>
      )}

      {mailAccounts === null ? (
        <div className={styles.loadingState}>Cargando casillas...</div>
      ) : (
        <MailAccountsTable rows={filteredMailAccounts} emptyMessage={emptyMessage} onSelect={openMailAccount} />
      )}

      <MailAccountDetailModal
        mailAccount={selectedMailAccount}
        onClose={closeMailAccount}
        onUpdateMailAccount={updateSelectedMailAccount}
        onDeleted={removeMailAccount}
      />

      {isCreating && (
        <CreateMailAccountModal
          accounts={accounts}
          defaultAccountId={defaultAccountId}
          onClose={closeCreate}
          onCreated={addMailAccount}
        />
      )}
    </>
  );
}
